import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "template-select" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " Шаблон приёма ", -1)

import {
    computed,
    ref,
} from 'vue';
import {
    keyBy,
    NumericDictionary,
} from 'lodash';
import {
    IMedication,
    IMedicationCourse,
} from '../../../../life-impulse-tools/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateSelect',
  props: {
    allowClear: { type: Boolean, default: true },
    medicationMap: { default: undefined },
    subtypesMap: { default: undefined },
    course: { default: undefined },
    disabled: { type: Boolean, default: false }
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }: { emit: ({(e: 'change', value: number | undefined, course?: IMedicationCourse): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { allowClear: boolean, medicationMap: NumericDictionary<IMedication>, subtypesMap: NumericDictionary<IMedication>, course: IMedicationCourse, disabled: boolean }




const hasFocus = ref(false);
const defocus = () => {
    hasFocus.value = false;
};

const medication = computed(() => {
    if (!props.course || !props.medicationMap || !props.subtypesMap) {
        return undefined;
    }
    if (!props.course.clinicMedicationId) {
        throw new Error('TemplateSelect: no clinicMedicationId provided.');
    }
    const subtype = props.subtypesMap[props.course.clinicMedicationId];
    return subtype
        ? props.medicationMap[subtype.parentId!]
        : props.medicationMap[props.course.clinicMedicationId];
});
const templates = computed(() => {
    let subtype = null;
    if (!medication.value || !props.subtypesMap) {
        return [];
    }

    if (props.course.medicationSubtypeId) {
        subtype = props.subtypesMap[props.course.medicationSubtypeId];
    }
    return subtype && subtype.recipes?.length
        ? subtype.recipes
        : medication.value.recipes;
});
const templatesMap = computed(() => keyBy(templates.value, 'id'));
const selectedTemplate = computed(() => {
    if (props.course.times === undefined) {
        return null;
    }
    const similarTemplate = (templates.value || [])
        .filter(
            (template) => template.times
                && template.times.length
                && template.times.length === props.course.times?.length
                && template.daysTakePeriod === props.course.daysTakePeriod,
        )
        .find(
            ({ times: dailyDoses }) => (dailyDoses || []).every((dose, i) => {
                if (!props.course.times) {
                    return null;
                }
                const doseEntry = props.course.times[i];
                const templateESValue = !!dose.onEmptyStomach;
                const currentESValue = !!props.course.times?.[i].onEmptyStomach;

                const curDepId = dose.intakeDependencyId;
                let curDayActionId = null;
                if ([1, 3].includes(curDepId)) {
                    curDayActionId = doseEntry?.dayActionId;
                } else if (curDepId === 2) {
                    curDayActionId = doseEntry?.intakeDependencyId === 2
                        ? doseEntry?.dayActionId : null;
                } else if (curDepId === 4) {
                    curDayActionId = doseEntry?.intakeDependencyId === 4
                        ? dose.dayActionId : null;
                }

                const minutesDeviationIsEqual = curDepId !== 2
                    || dose.minutesDeviation === doseEntry?.minutesDeviation;

                return dose.dayActionId === curDayActionId
                    && dose.takeDirection === doseEntry.takeDirection
                    && dose.medicationPortion === doseEntry.medicationPortion
                    && dose.intakeDependencyId === doseEntry.intakeDependencyId
                    && dose.notificationPeriodId === doseEntry.notificationPeriodId
                    && dose.intakeFormId === doseEntry.intakeFormId
                    && dose.daysTakeRegularity === doseEntry.daysTakeRegularity
                    && (dose.daysTakeOffset || 0) === doseEntry.daysTakeOffset
                    && minutesDeviationIsEqual
                    && templateESValue === currentESValue;
            }),
        );

    return similarTemplate ? similarTemplate.id : null;
});

const calculateTemplateName = (id: number | null) => {
    if (!id) {
        return '';
    }
    const template = templatesMap.value[id];
    const dosesCount = (template.times || []).map((dose) => {
        const daysCount = template.daysTakePeriod - dose.daysTakeOffset;
        if (template.daysTakePeriod <= dose.daysTakeOffset) {
            return 0;
        }
        return Math.ceil(daysCount / dose.daysTakeRegularity);
    }).reduce((a, b) => a + b, 0);
    return `${dosesCount} прием(ов) ${
        template.times?.length || 0} типов в течение ${template.daysTakePeriod} дней`;
};

const onTemplateSelect = (val?: number) => {
    defocus();
    const template = templates.value?.find((x) => x.id === val);
    emits(
        'change',
        template?.id,
        template
            ? {
                ...props.course,
                daysTakePeriod: template?.daysTakePeriod,
                times: (template.times || [])
                    .map((time) => ({
                        ...time,
                        id: undefined,
                        recipeId: undefined,
                    })),
                id: props.course.id,
            }
            : undefined,
    );
};

const getPopupContainer = (trigger: HTMLElement) => trigger.parentElement;

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _hoisted_2,
    (__props.disabled || !hasFocus.value)
      ? (_openBlock(), _createBlock(_component_a_input, _mergeProps({ key: 0 }, _ctx.$attrs, {
          disabled: __props.disabled,
          value: calculateTemplateName(_unref(selectedTemplate)),
          onFocus: _cache[0] || (_cache[0] = ($event: any) => (hasFocus.value = true))
        }), null, 16, ["disabled", "value"]))
      : (_openBlock(), _createBlock(_component_a_select, _mergeProps({ key: 1 }, _ctx.$attrs, {
          "default-open": "",
          value: _unref(selectedTemplate),
          "dropdown-match-select-width": false,
          "get-popup-container": getPopupContainer,
          "allow-clear": __props.allowClear,
          onChange: onTemplateSelect,
          onBlur: defocus
        }), {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templates), (template) => {
              return (_openBlock(), _createBlock(_component_a_select_option, {
                key: template.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(calculateTemplateName(template.id)), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 16, ["value", "allow-clear"]))
  ]))
}
}

})